import { MdOutlineLocalPhone } from "react-icons/md";
import { GoMail } from "react-icons/go";
import { CompanyInformationsType } from "@/Types/GlobalTypes";

interface ComponentProps {
  informations: CompanyInformationsType
}

export default function CommunicationField({ informations }: ComponentProps) {
  return (
    <>
      <div className="flex flex-col md:flex-row md:space-x-10 space-y-4 md:space-y-0 items-center justify-center text-[14px] max-[750px]:hidden">
        <div className="flex items-center gap-2">
          <MdOutlineLocalPhone className="text-lg" />
          <a href="tel:905375224051" className="hover:underline">{informations.contactNumber}</a>
        </div>

        <div className="flex items-center gap-2">
          <GoMail className="text-lg" />
          <a title="Contact Us" href="mailto:info@caressflow.com.tr" className="hover:underline">
            {informations.contactMail}
          </a>
        </div>
      </div>

      <div className="min-[750px]:hidden items-center text-[14px] flex w-full justify-between">
        <div className="flex items-center gap-2">
          <MdOutlineLocalPhone className="text-lg" />
          <a href="tel:905375224051" className="hover:underline">Bizi arayın!</a>
        </div>

        <div className="flex items-center gap-2">
          <GoMail className="text-lg" />
          <a title="Contact Us" href="mailto:info@caressflow.com.tr" className="hover:underline">
            Bize ulaşın!
          </a>
        </div>
      </div>

    </>
  )
}
